import { render, staticRenderFns } from "./scatterChart.vue?vue&type=template&id=2362675c"
import script from "./scatterChart.vue?vue&type=script&lang=js"
export * from "./scatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports